export const EVENTS = {
  USER_UPDATED: "USER_UPDATED",
  NOTIFICATION_RECEIVED: "notification_event",
  MY_WORK_INVALIDATED: "my_work_invalidated",
};


